// FRIENDLY PLAY screens — the study-area picker and the untimed question card
// (PLAN-gameplay-round2.md Part 2). Both are rendered by friendlyController.ts.
//
// The play surface deliberately REUSES the scored play screen's classes
// (.play / .play-head / .chip / .qprog / .qbody / .options .opt / .reveal) so
// the question card looks identical — minus the two things the plan forbids
// here: the .meter (the draining $1,000 readout) and the hint row. Element IDs
// are its OWN (fr*) so gameController's timers and queries can never collide
// with a study session.
import { tutorialInfoButtonHTML } from '../tutorialOverlay';

export const friendlyHTML = /* html */ `
<div id="screenFriendly" class="friendly-screen hidden">
  <button class="btn secondary back" id="frBackBtn" type="button" style="width:auto;padding:10px 16px;">← Home</button>
  <div class="content-head">
    <div class="content-title">Friendly Play${tutorialInfoButtonHTML('friendly')}</div>
    <div class="content-sub">Study at your own pace. No clock, no coins.</div>
  </div>
  <div id="frList" class="fr-list"></div>
</div>

<div id="screenFriendlyPlay" class="play friendly-play hidden">
  <div class="play-head">
    <button class="fr-quit" id="frQuitBtn" type="button">← Study areas</button>
  </div>
  <!-- Question progress row (mockup): count left, segmented pills right. -->
  <div class="fr-progrow">
    <span class="fr-progtxt" id="frProg">Question 1 of 10</span>
    <span class="frh-seg" id="frSeg" aria-hidden="true"></span>
  </div>
  <!-- The warm place (Eric 2026-09-06): a rotating hero scene with Theo —
       friendlyController.applySessionHero() sets image, pose, and caption. -->
  <div class="frh-hero" id="frHero">
    <img class="frh-theo" id="frHeroTheo" src="/media/characters/theo-welcome.png" alt="" aria-hidden="true"/>
    <div class="frh-text">
      <div class="frh-t">Take your time.</div>
      <div class="frh-s">Let&rsquo;s learn together.</div>
    </div>
    <span class="frh-cap" id="frHeroCap"></span>
  </div>
  <div class="fr-area-row"><span class="chip" id="frArea">Study</span></div>
  <div class="qbody" id="frBody">…</div>
  <div class="options" id="frOptions"></div>
  <div class="frh-hint" id="frHint">Choose an answer.</div>
  <div class="reveal fr-reveal" id="frReveal"></div>
  <button class="btn fr-next hidden" id="frNextBtn" type="button">Next question →</button>
  <div class="fr-end hidden" id="frEnd"></div>
</div>`;
